import { getStreamParams } from '@wix/da-shared-react/pkg/Stream/base/selectors';
import {
  MessageLogStreamParams,
  ActionLogStreamParams,
} from '../../types/groupsBackroom';
import {
  GROUP_MESSAGELOG_IDS_STREAM,
  GROUP_ACTIONLOG_IDS_STREAM,
} from '../streams';

const messageLogParamDefaults: MessageLogStreamParams = {
  sortBy: 'newest',
};

const actionLogParamDefaults: ActionLogStreamParams = {
  sortValue: 'newest',
};

export function getMessageLogParams(state): MessageLogStreamParams {
  return {
    ...messageLogParamDefaults,
    ...(getStreamParams(state, GROUP_MESSAGELOG_IDS_STREAM) ?? {}),
  };
}

export function getActionLogParams(state): ActionLogStreamParams {
  return {
    ...actionLogParamDefaults,
    ...(getStreamParams(state, GROUP_ACTIONLOG_IDS_STREAM) ?? {}),
  };
}
